import { render } from "./NewEmployeesCreate.vue?vue&type=template&id=87c8f864&ts=true"
import script from "./NewEmployeesCreate.vue?vue&type=script&lang=ts"
export * from "./NewEmployeesCreate.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\development\\source\\repositories\\Koncepta\\Core.Services\\Core.WebApp\\admin-ui\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__